import React from 'react';
import { createRoot } from 'react-dom/client';

import './styles.sass';
import { initSentry } from 'shared/helper/sentry';

import DetailsPage from './components/details_page';

const container = document.querySelector('.details-page-wrapper');
const root = createRoot(container);
const config = JSON.parse(container.getAttribute('data-config'));
if (!!config.sentry_dsn) {
    initSentry(config.sentry_dsn, RELEASE);
}

root.render(<DetailsPage config={config} />);
